import { NavLink, Outlet, useParams } from "react-router-dom";
import { messageAndErrorStore, projectStore } from "../../store/Store";
import MessageCard from "../../components/MessageCard";
import useGetFetch from "../../hooks/useGetFetch";
import Loading from "../../components/Loading";
import ErrorDisplay from "../../components/ErrorDisplay";

export default function ProjectInvoices() {
  const currentProject = projectStore((data) => data.currentProject);
  const setCurrentProject = projectStore((data) => data.setCurrentProject);
  const messageTrigger = messageAndErrorStore((data) => data.messageTrigger);
  const pageError = messageAndErrorStore((messages) => messages.error);
  const successMessage = messageAndErrorStore(
    (messages) => messages.successMessage,
  );
  
  const { id } = useParams("id");

  const {
      isPending: projectPending,
      error: projectError,
      statusCode: projectCode,
    } = useGetFetch(
      `${process.env.REACT_APP_BACKEND}/pc/project/${id}`,
      setCurrentProject,
    );

  if (projectPending) {
    return <Loading />
  }
  if (projectError) {
    return <ErrorDisplay message={"Something went wrong"} code={projectCode} />
  }
  return (
    <div className="container-fluid">
      {messageTrigger && (
        <MessageCard errorMessage={pageError} successMessage={successMessage} />
      )}
      <div className="row">
        <div className="col mb-5">
        <h2>{`${currentProject.project.job_name} - Invoices`}</h2>
        </div>
        <div className="col">
        <div className="d-flex justify-content-start">
          <NavLink
            to={`/project/${id}/invoices/customer-invoices`}
            className="invoice-link"
          >
            Customer Invoices
          </NavLink>
          <NavLink
            to={`/project/${id}/invoices/vendor-invoices`}
            className="invoice-link"
          >
            Vendor Invoices
          </NavLink>
        </div>

        </div>
      </div>
      <Outlet />
    </div>
  );
}
